import React, { FC, SyntheticEvent } from 'react';

import PropTypes from 'prop-types';

import Button from '@adsk/alloy-react-button';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-helpers';
import { RenderIconType } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

type PaginationButtonProps = StylableComponent<HTMLDivElement> & {
  onClick?: (e: SyntheticEvent) => void;
  disabled?: boolean;
  renderIcon: RenderIconType;
};

const PaginationButton: FC<PaginationButtonProps> = ({
  onClick,
  disabled,
  renderIcon,
  style,
}) => (
  <Button
    onClick={onClick}
    disabled={disabled}
    variant={Button.VARIANTS.TERTIARY}
    size={Button.SIZES.SMALL}
    style={[
      {
        color: disabled ? theme.colors.charcoal500 : theme.colors.charcoal900,
        padding: 0,
        pointerEvents: disabled ? 'none' : 'inherit',
      },
      style,
    ]}
  >
    {renderIcon?.({ size: 20 })}
  </Button>
);

PaginationButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  renderIcon: PropTypes.func.isRequired,
  style: stylePropType,
};

export default PaginationButton;
